import {API_DRIVER} from "../configs/axios";

const DeviceService = {
    fetchDevices: (query, cancelToken) => {
        return API_DRIVER.get(`/api/device${query}`, {
            withCredentials: true,
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
            cancelToken: cancelToken
        })
    },
    fetchWrenchDetails: (body) => {
        return API_DRIVER.post("/api/device/wrenchDetails", body)
    },
    fetchDeviceDetails: (deviceId, integrationId) => {
        return API_DRIVER.get(`/api/device/${deviceId}/customer/${integrationId}`, {
            withCredentials: true,
            headers: {
                "Access-Control-Allow-Origin": "*",
            }
        })
    },
    updateAssociations: (tags, clientName, objectCategoryName, integrationId, objectExternalId) => {
        const body = {
            tags: tags,
            clientName: clientName,
            objectCategoryName: objectCategoryName,
            integrationId: integrationId,
            objectExternalId: objectExternalId
        }

        return API_DRIVER.post('/api/tags/updateAssociations', body)
    },
    fetchFilterData: (integrationId, withCollaborators) => {
        return API_DRIVER.get(`/api/device/filter-data`, {
            params: {
                companyId: integrationId,
                withCollaborators: withCollaborators
            }
        })
    },
    downloadCsvFromOrder: (orderId, integrationId) => {
        return API_DRIVER(`/api/device/order/csv/${orderId}/customer/${integrationId}`, {
            responseType: 'blob'
        })
    },
    fetchFilterSuggestions: (query, cancelToken) => {
        return API_DRIVER.get(`/api/device/autocomplete${query}`, {
            cancelToken: cancelToken
        })
    },
    sendVpServiceRequest: (body) => {
        return API_DRIVER.post("/api/device/vpService", body, {
            withCredentials: true,
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
        })
    },
    checkActiveSr: (body) => {
        return API_DRIVER.post("/api/device/wrenchDetails", body)
    },
    fetchCollaborators: (body, query) => {
        return API_DRIVER.post(`/api/device/collaborators${query}`, body)
    },
    addCollaborators: (body, query) => {
        return API_DRIVER.post(`/api/device/addCollaborator${query}`, body)
    },
    fetchDevicesNotKaskoCustom: (query) => {
        return API_DRIVER.get(`/api/device/tipologia-assistenza/not-kasko-custom${query}`)
    },
    fetchDevicesKaskoCustom: (query) => {
        return API_DRIVER.get(`/api/device/tipologia-assistenza/kasko-custom${query}`)
    }
}

export default DeviceService
